/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  SaasBenchmarkRequest,
  SaasBenchmarkResponse,
  SaasMetricsCombinationsResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiGrowthLeadsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-growth-leads-controller
   * @name ProvideBenchmarkResultForRequest
   * @request POST:/api/v1/growth-leads/saas-benchmark/find-result
   */
  provideBenchmarkResultForRequest = (data: SaasBenchmarkRequest, params: RequestParams = {}) =>
    this.http.request<SaasBenchmarkResponse, any>({
      path: `/v1/growth-leads/saas-benchmark/find-result`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static provideBenchmarkResultForRequestPath = '/v1/growth-leads/saas-benchmark/find-result'
  static provideBenchmarkResultForRequestMethod = 'POST'
  /**
   * No description
   *
   * @tags api-growth-leads-controller
   * @name GetAvailableMetricsCombinations
   * @request GET:/api/v1/growth-leads/saas-benchmark/metrics-combinations
   */
  getAvailableMetricsCombinations = (params: RequestParams = {}) =>
    this.http.request<SaasMetricsCombinationsResponse, any>({
      path: `/v1/growth-leads/saas-benchmark/metrics-combinations`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAvailableMetricsCombinationsPath =
    '/v1/growth-leads/saas-benchmark/metrics-combinations'
  static getAvailableMetricsCombinationsMethod = 'GET'
}
